<h3-annotation-layout>
  <h3-layers
    projection-location="main-image"
    *ngIf="state.status === 'ready'"
    [primaryOutputInjector]="primaryOutputInjector"
    [calibrationData]="calibrationData$ | async"
  ></h3-layers>

  <div
    projection-location="right-collapsing-section"
    *ngIf="state.status === 'ready'"
    class="right-collapsing-section"
  >
    <h3-shape-list-and-tag-editor
      *ngIf="(isInSplitView$ | async) === false"
    ></h3-shape-list-and-tag-editor>
  </div>

  <h3-cv-toolbar
    *ngIf="
      isObjectsEnabled &&
      (isSelectedOutput$ | async) &&
      (isInSplitView$ | async) === false
    "
    projection-location="global-toolbar"
  ></h3-cv-toolbar>

  <div
    projection-location="toolbars"
    class="toolbar-grid"
    *ngIf="state.status === 'ready' && !isObjectsEnabled"
    [hidden]="(interactionModeIsCanvas$ | async) || (isThumbnail$ | async)"
  >
    @if (isInSplitView$ | async) {
      <div id="video-layout-split-view" class="layout-row split-view">
        <h3-split-view-main-video-toolbar
          *h3Injector="contentInjector"
        ></h3-split-view-main-video-toolbar>
        @if (showProjectionSettings$ | async) {
          <h3-toggle-point-cloud-projection-button></h3-toggle-point-cloud-projection-button>
          <h3-toggle-shape-projection-button></h3-toggle-shape-projection-button>
        }
        <h3-toggle-split-view-button></h3-toggle-split-view-button>
        <h3-help-button></h3-help-button>
      </div>
    }

    <div class="layout-row" [hidden]="isInSplitView$ | async">
      <h3-secondary-toolbar-2d-objectless
        *h3Injector="contentInjector"
      ></h3-secondary-toolbar-2d-objectless>

      <div class="output-controls">
        <h3-vector-tagging-layer-view-settings *h3Injector="contentInjector">
          <div *ngIf="primaryOutputInjector">
            <div class="view-settings-title">Point-cloud Settings</div>
            <h3-point-cloud-layer-view-settings-popover
              *h3Injector="primaryOutputInjector"
            ></h3-point-cloud-layer-view-settings-popover>
            <div class="view-settings-title" *ngIf="!isOrthographicProjection">
              Video Settings
            </div>
            <div class="view-settings-title" *ngIf="isOrthographicProjection">
              Orthographic Settings
            </div>
          </div>

          <h3-vector-tagging-layer-view-settings-popover
            *h3Injector="contentInjector"
            [isOrthographic]="isOrthographicProjection"
          ></h3-vector-tagging-layer-view-settings-popover>
        </h3-vector-tagging-layer-view-settings>

        <h3-inspect-button></h3-inspect-button>

        <h3-sync-subpoint-shapes-button
          *ngIf="
            showSyncSubpointShapesButton &&
            ((interactionModeIsCanvas$ | async) || (isThumbnail$ | async)) ===
              false
          "
        ></h3-sync-subpoint-shapes-button>

        <h3-undo-redo-buttons
          *ngIf="(readOnly$ | async) !== true"
        ></h3-undo-redo-buttons>

        <h3-help-button></h3-help-button>
        <h3-show-feedback-button></h3-show-feedback-button>
        <h3-right-collapsing-button
          *ngIf="(this.isRightPanelExpanded$ | async) === false"
        ></h3-right-collapsing-button>
      </div>
    </div>
    <div class="layout-row" [hidden]="isInSplitView$ | async">
      <h3-main-video-toolbar-objectless
        *h3Injector="contentInjector"
      ></h3-main-video-toolbar-objectless>
      <h3-toggle-split-view-button
        *ngIf="isSplitViewEnabled"
      ></h3-toggle-split-view-button>
      @if (
        (showProjectionSettings$ | async) &&
        (readOnly$ | async) === false &&
        (isInSplitView$ | async) === false
      ) {
        <h3-enable-3d-shortcuts-toggle
          *h3Injector="contentInjector"
        ></h3-enable-3d-shortcuts-toggle>
      }
      @if (showProjectionSettings$ | async) {
        <h3-toggle-point-cloud-projection-button></h3-toggle-point-cloud-projection-button>
        <h3-toggle-shape-projection-button></h3-toggle-shape-projection-button>
        @if (shouldShowCalibrationSettings) {
          <h3-calibration-settings-button
            *h3Injector="primaryOutputInjector"
            [injector]="primaryOutputInjector"
            [videoOutputName]="outputName"
          ></h3-calibration-settings-button>
        }
      }
      @if (areAllInFusionSingleFrame$ | async) {
        <h3-coordinates-box
          *h3Injector="contentInjector"
          class="single-frame"
          [conversionFunction]="convertToPointCloudCoordinates"
        ></h3-coordinates-box>
      }
    </div>
  </div>

  <div
    class="layout-row"
    *ngIf="state.status === 'ready' && (isInSplitView$ | async) === false"
    projection-location="timeline-section"
  >
    <h3-ml-assist *ngIf="isMlExtrapolationEnabled"></h3-ml-assist>
    <h3-focusable-scrubber></h3-focusable-scrubber>
    @if ((areAllInFusionSingleFrame$ | async) === false) {
      <h3-coordinates-box
        *h3Injector="contentInjector"
        [conversionFunction]="convertToPointCloudCoordinates"
      ></h3-coordinates-box>
    }
  </div>
</h3-annotation-layout>
